import { classes } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

export class IntersectionState extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.hasAttribute('disabled')) {
      return;
    }

    this.observer = new IntersectionObserver(
      ([{ isIntersecting }], observer) => {
        if (isIntersecting) {
          this.container.classList.add(classes.intersected);

          if (this.hasAttribute('enable-intersecting')) {
            this.container.classList.add(classes.intersecting);
            return;
          }

          observer.disconnect();
          return;
        }

        if (this.hasAttribute('enable-intersecting')) {
          this.container.classList.remove(classes.intersecting);
        }
      },
      {
        rootMargin: this.getAttribute('root-margin') ?? '0px',
        threshold: this.hasAttribute('threshold') ? parseInt(this.getAttribute('threshold')) : 0.25,
      }
    );

    this.observer.observe(this.container);
  }

  get container() {
    return this.targets.container ?? this;
  }
}
